import React from 'react';

import styles from 'styles/tableHeader.css';
import { SORT_TYPES } from 'common/constants';

const TableHeader = props => {
  const {
    enableSort = true,
    label,
    filterActive,
    columnHeader,
    handleOnFilterButtonClick,
    handleOnSortClick,
    handleOnSortKeyPress,
    lastElement,
    sortBy,
    sortDirection,
    selectedPopover,
    Popover,
  } = props;

  const cn = !lastElement ? styles.columnFilter : styles.lastColumnFilter;
  const activeCn = !filterActive
    ? styles.filterButton
    : styles.filterButtonActive;

  let sortDirectionIcon = <div className={styles.sortDirectionNone} />;

  if (enableSort && sortBy === columnHeader) {
    switch (sortDirection) {
      case SORT_TYPES.DESC:
        sortDirectionIcon = <div className={styles.sortDirectionDesc} />;
        break;
      case SORT_TYPES.ASC:
        sortDirectionIcon = <div className={styles.sortDirectionAsc} />;
        break;
      case null:
      default:
        break;
    }
  }

  return (
    <div className={styles.headerWithControls}>
      {enableSort && (
        // eslint-disable-next-line jsx-a11y/interactive-supports-focus
        <div
          className={styles.columnHeader}
          onClick={() => {
            if (handleOnSortClick) handleOnSortClick(columnHeader);
          }}
          onKeyPress={() => {
            if (handleOnSortKeyPress) handleOnSortKeyPress(columnHeader);
          }}
          role="button"
        >
          {label}
          {sortDirectionIcon}
        </div>
      )}
      {!enableSort && <div className={styles.columnHeaderNoSort}>{label}</div>}

      {Popover && (
        <div className={cn}>
          <button
            type="button"
            className={activeCn}
            onClick={() => handleOnFilterButtonClick(columnHeader)}
            data-action="filter"
            data-label={columnHeader}
          >
            Filter
          </button>
          {selectedPopover === columnHeader && (
            <div className={styles.popoverWrapper}>{Popover}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/views/components/Table/TableHeader.jsx